import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import {
  type AccessRight,
  ROLE_OPTIONS_MAP,
} from 'lumen/utils/constants/users-constants';

interface SettingsUsersTablesCellsCellRoleReadOnlySignature {
  Args: {
    cellData: AccessRight;
  };
}

export default class CellRoleReadOnly extends Component<SettingsUsersTablesCellsCellRoleReadOnlySignature> {
  @service declare intl: Services['intl'];

  get label(): string {
    const key = ROLE_OPTIONS_MAP[this.args.cellData];
    return key ? this.intl.t(key) : this.args.cellData;
  }

  <template>{{this.label}}</template>
}
